<!-- 项目文件 -->
<template>
    <div class="mt16 pb50 bgfff pl16 pr16 pt24">
        <p class="fs16 c333 disinblock posre textc w100p flexc">
            <span class="border-bottom1">
                智能化驾校培训
            </span>
        </p>
        <P class="fs12 c999 pt12 textc">点击图标查看详情</P>
        <div class="w100p  pt24">
            <ul class="overflow w100p row1_txtc">
                <li class="w30p pt5 pb5 fs14 c333 pt6 pb6  textc bgED  disinblock bradius50" :class="{bgact:isAct == 1}" @click="changeBg(1)">
                    驾校定制APP
                </li>
                <li class="w30p pt5 pb5 fs14 c333 pt6 pb6  textc bgED  disinblock bradius50" :class="{bgact:isAct == 2}"
                    @click="changeBg(2)">
                    教练教学APP
                </li>
                <li class="w30p pt5 pb5 fs14 c333 pt6 pb6  textc bgED  disinblock bradius50" :class="{bgact:isAct == 3}"
                    @click="changeBg(3)">
                    校长管理APP
                </li>
            </ul>
          
        </div>

        <transition name="fade">
            <div v-show="isAct==1">
                <van-grid :column-num="3" :border="false">
                    <van-grid-item @click="openImg(1)">
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img23.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">驾校</p>
                            <P class="fs14 c333">专属首页</P>
                        </div>
                    </van-grid-item>

                    <van-grid-item @click="openImg(2)">
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img24.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">驾校专属 </p>
                            <P class="fs14 c333">场地设施展示</P>
                        </div>
                    </van-grid-item>

                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img25.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">驾校教练示</p>
                            <P class="fs14 c333">专属风采展</P>
                        </div>
                    </van-grid-item>

                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img26.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">全新</p>
                            <P class="fs14 c333">模拟题库</P>
                        </div>
                    </van-grid-item>

                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img27.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">驾校专属</p>
                            <P class="fs14 c333">教学视频</P>
                        </div>
                    </van-grid-item>

                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img28.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">在线预约</p>
                            <P class="fs14 c333">上车练习</P>
                        </div>
                    </van-grid-item>

                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img29.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">全新</p>
                            <P class="fs14 c333">模拟题库复制</P>
                        </div>
                    </van-grid-item>

                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img30.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">驾校专属</p>
                            <P class="fs14 c333">教学视频</P>
                        </div>
                    </van-grid-item>

                </van-grid> 
            </div>
        </transition>
        <transition name="fade">
            <div v-show="isAct==2">
                <van-grid :column-num="3" :border="false">
            
                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img31.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">课程/教练</p> 
                            <P class="fs14 c333">自主排课</P>
                        </div>
                    </van-grid-item>
            
                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img32.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">教学 </p>
                            <P class="fs14 c333">任务管理</P>
                        </div>
                    </van-grid-item>
            
                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img33.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">教学日志 </p>
                            <P class="fs14 c333">记录查询</P>
                        </div>
                    </van-grid-item>
            
                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img34.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">学员学习 </p>
                            <P class="fs14 c333">进度查询、管理</P>
                        </div>
                    </van-grid-item>
            
                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img35.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">学员学习 </p>
                            <P class="fs14 c333">状态日志点评</P>
                        </div>
                    </van-grid-item>

                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img36.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">一键 </p>
                            <P class="fs14 c333">联系学员</P>
                        </div>
                    </van-grid-item>
            
                </van-grid>
            </div>
        </transition>
        <transition name="fade">
            <div v-show="isAct==3">
                <van-grid :column-num="3" :border="false">
            
                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img37.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">驾校招生 </p>
                            <P class="fs14 c333">数据统计分析</P>
                        </div>
                    </van-grid-item>
            
                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img38.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">驾校培训  </p>
                            <P class="fs14 c333">考试数据分析</P>
                        </div>
                    </van-grid-item>
            
                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img39.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">车辆使用 </p>
                            <P class="fs14 c333">情况分析统计</P>
                        </div>
                    </van-grid-item>
            
                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img40.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">教练考勤 </p>
                            <P class="fs14 c333">数据统计分析</P>
                        </div>
                    </van-grid-item>
            
                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img41.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">驾校教学培 </p>
                            <P class="fs14 c333">训进度分析</P>
                        </div>
                    </van-grid-item>
            
                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img42.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">驾校教学 </p>
                            <P class="fs14 c333">调度统计分析</P>
                        </div>
                    </van-grid-item>
            
                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img29.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">全新</p>
                            <P class="fs14 c333">模拟题库复制</P>
                        </div>
                    </van-grid-item>
            
                    <van-grid-item>
                        <div class="icon-img">
                            <img class="w70 h70" src="../../public/img/img30.png" alt="">
                        </div>
                        <div class="icon-text textc">
                            <p class="fs14 c333">驾校专属</p>
                            <P class="fs14 c333">教学视频</P>
                        </div>
                    </van-grid-item>
            
                </van-grid>
            </div>
        </transition>



        <div class="posfix w100p h100p top0 left0 bgfff zindex999 alit" v-if="clickGrid==1">
            <div class="w65p mauto">
                <van-image lazy-load v-if="imgGrid==index+1" v-for="(item,index) in imgList" :key="index" class="imgauto" :src="item" />
                
                <span class="disblock verbot textc" @click="closeImg()">
                    <img class="w44 h44 " src="../../public/img/img44.png" alt="">
                </span>
            </div>
        </div>

    </div>
</template>

<script>
    import $ from "jquery";
    export default {
        data() {
            return {
                isAct: 1,
                clickGrid: 0,
                imgGrid: 0,
                imgList: [
                    require('../../public/img/img43.png'),
                    require('../../public/img/img6.png'),
                ]
            };
        },
        components: {

        },
        methods: {
            changeBg(index) {
                this.isAct = index;
            },
            openImg(index) {
                this.clickGrid = 1;
                this.imgGrid = index;
                $('body').css("overflow", "hidden")
            },
            closeImg() {
                this.clickGrid = 0;
                $('body').css("overflow", "auto")
            }
        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>
    .bgact {
        color: #3F8DF7;
        font-weight: 600;
        background-color: #EDF2FF;
    }
</style>